import { render } from "./HistoryColumn.vue?vue&type=template&id=05142afe&scoped=true"
import script from "./HistoryColumn.vue?vue&type=script&lang=js"
export * from "./HistoryColumn.vue?vue&type=script&lang=js"

import "./HistoryColumn.vue?vue&type=style&index=0&id=05142afe&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05142afe"]])

export default __exports__